var a;!function(a){a.PROD="prod",a.STAGE="stage",a.QA="qa"}(a||(a={}));var r=a;export{r as default};
